import React from "react";
import {
  AboutContainer,
  AboutHeading,
  AboutText,
  Container,
  Image,
  ImageContainer,
  ImageText,
  ImageOverlay,
} from "./about";
import Shruti from "../../images/Shruti.jpg";

export default function AboutMe() {
  return (
    <>
      <Container>
        <ImageContainer className="container">
          <Image src={Shruti} />
          <ImageOverlay />
          <ImageText>
            <h3>Stop hovering</h3>
            <p>Nothing to see here</p>
          </ImageText>
        </ImageContainer>
        <AboutContainer>
          <AboutHeading>Who am I?</AboutHeading>
          <AboutText>
            The name's Shruti. Honestly, I just got excited about having a whole
            page just for me.
            <AboutText /> If you've come this far, you really want to know me.
            So here goes.
            <AboutText /> I go to Northeastern, currently pursuing a Master's in
            Computer Science degree in Boston. I am set to graduate in May 2024.
            <AboutText />
            My haunts lie in feeding my curiosity. I got into coding during high
            school and I decided to set camp here because I like making my brain
            work. I reminisce looking at my projects, experiences, seeing how
            far I've come on my own. My back-up plan is to solve murders. Or the
            opposite, perhaps.
            <AboutText /> When I'm not coding, you'll find me devouring books or
            watching hand-picked TV overnight. To me, music is everything.
          </AboutText>
        </AboutContainer>
      </Container>
    </>
  );
}
